import { UseDisclosureProps } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import { InfoModal } from "design_system/components/Modal";
import { RegionType } from "graphql/generated";
import { LOCALE_ITEM } from "src/constants/Locales";
import { checkCountry } from "src/utils/checkCountry";
import { getLocaleTypeByCountry } from "src/utils/getLocaleTypeByCountry";

export const CashbackModal = ({ isOpen, onClose }: UseDisclosureProps) => {
  const { t } = useTranslation(["wallet"]);
  const transNoahPointKey = "wallet:noah-points-popup";

  const title = checkCountry([RegionType.Jp])
    ? t(`${transNoahPointKey}:title`)
    : t("cashback-modal-title");

  const description = checkCountry([RegionType.Jp])
    ? t(`${transNoahPointKey}:content`)
    : t(`wallet:${getLocaleTypeByCountry(LOCALE_ITEM.region)}-cashback-modal-description`);

  return <InfoModal isOpen={isOpen} onClose={onClose} title={title} body={description} size="md" />;
};
